<template>
  <b-sidebar
    id="add-external-link-account"
    body-class="custom-scroll"
    v-model="showExternalLinkAccountSideBar"
    aria-labelledby="Add/Edit external link account"
    aria-label="Add/Edit external link account"
    shadow
    bg-variant="white"
    :backdrop-variant="`dark`"
    no-close-on-esc
    no-close-on-backdrop
    lazy
    backdrop
    right
    width="70vw"
    @hidden="sideBarHidden"
  >
    <template #header="{ hide }">
      <h3 class="font-21 theme-font-medium mb-0">
        Add new external link account
      </h3>
      <div class="sidebar-header-close">
        <a
          href="javascript:void(0)"
          aria-labelledby="Add external link account title"
          @click="
            hide;
            $emit('closeSideBar');
          "
          ><img src="../../assets/img/close.png" alt="close-tab"
        /></a>
      </div>
    </template>
    <template #default="{}">
      <b-form
        id="external-link-account-form"
        name="external-link-account-form"
        v-if="showForm"
        autocomplete="off"
        novalidate
      >
        <b-form-row>
          <b-col sm="12" md="6" lg="4">
            <b-form-group>
              <div class="floating-select-field">
                <b-form-select
                  id="authentication-method"
                  class="form-control"
                  v-model="authenticationMethod"
                  @input="authenticationMethod = $event"
                  :class="{
                    'is-value-exist': authenticationMethod != null,
                  }"
                >
                  <b-form-select-option value="azureB2C"
                    >Azure B2C</b-form-select-option
                  >
                </b-form-select>
                <label for="authentication-method">Authentication method</label>
              </div>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" lg="4">
            <b-form-group>
              <div class="floating-input-field">
                <b-form-input
                  id="external-link-account-name"
                  :class="{
                    'is-invalid':
                      !externalLinkAccountDetails.accountName && formSubmitted,
                  }"
                  type="text"
                  placeholder=" "
                  v-model="externalLinkAccountDetails.accountName"
                  required
                ></b-form-input>
                <label for="external-link-account-name"
                  >External link account name</label
                >
                <b-form-invalid-feedback
                  class="d-block"
                  v-if="
                    !externalLinkAccountDetails.accountName && formSubmitted
                  "
                  >Link account name required.</b-form-invalid-feedback
                >
              </div>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" lg="4" class="pt-md-2 mt-md-1">
            <b-form-group>
              <b-form-checkbox
                id="property-dependent"
                name="property-dependent"
                :disabled="isAddressSetupDone"
                v-model="externalLinkAccountDetails.isForEachProperty"
              >
                Property dependent
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row v-if="isAddressSetupDone">
          <b-col>
            <h6 class="font-14">
              <InfoCircelYellow class="mr-1 mt-n1" />
              {{ DISPLAY_MESSAGES.ADDRESS_SETUP_NOT_DONE_LINK_ACCOUNT_ERROR }}
            </h6>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="12" lg="10">
            <b-form-group>
              <div class="floating-input-field">
                <b-form-input
                  id="auth-code-end-point"
                  :class="{
                    'is-invalid':
                      (!externalLinkAccountDetails.tenantAuthCodeEndPoint &&
                        formSubmitted) ||
                      (!validateUrl(
                        externalLinkAccountDetails.tenantAuthCodeEndPoint
                      ) &&
                        formSubmitted),
                  }"
                  type="text"
                  placeholder=" "
                  v-model="externalLinkAccountDetails.tenantAuthCodeEndPoint"
                  required
                ></b-form-input>
                <label for="auth-code-end-point">Auth code endpoint</label>
                <b-form-invalid-feedback
                  class="d-block"
                  v-if="
                    !externalLinkAccountDetails.tenantAuthCodeEndPoint &&
                    formSubmitted
                  "
                  >Auth code endpoint required.</b-form-invalid-feedback
                >
                <b-form-invalid-feedback
                  class="d-block"
                  v-if="
                    externalLinkAccountDetails.tenantAuthCodeEndPoint &&
                    formSubmitted &&
                    !validateUrl(
                      externalLinkAccountDetails.tenantAuthCodeEndPoint
                    )
                  "
                  >Invalid url.</b-form-invalid-feedback
                >
              </div>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="12" lg="10">
            <b-form-group>
              <div class="floating-input-field">
                <b-form-input
                  id="access-token-end-point"
                  :class="{
                    'is-invalid':
                      (!externalLinkAccountDetails.tenantAccessTokenEndPoint &&
                        formSubmitted) ||
                      (!validateUrl(
                        externalLinkAccountDetails.tenantAccessTokenEndPoint
                      ) &&
                        formSubmitted),
                  }"
                  type="text"
                  placeholder=" "
                  v-model="externalLinkAccountDetails.tenantAccessTokenEndPoint"
                ></b-form-input>
                <label for="access-token-end-point"
                  >Access token endpoint</label
                >
                <b-form-invalid-feedback
                  class="d-block"
                  v-if="
                    !externalLinkAccountDetails.tenantAccessTokenEndPoint &&
                    formSubmitted
                  "
                  >Access token endpoint required.</b-form-invalid-feedback
                >
                <b-form-invalid-feedback
                  class="d-block"
                  v-if="
                    externalLinkAccountDetails.tenantAccessTokenEndPoint &&
                    formSubmitted &&
                    !validateUrl(
                      externalLinkAccountDetails.tenantAccessTokenEndPoint
                    )
                  "
                  >Invalid url.</b-form-invalid-feedback
                >
              </div>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="12" lg="10">
            <b-form-group>
              <div class="floating-input-field">
                <b-form-input
                  id="client-id"
                  :class="{
                    'is-invalid':
                      !externalLinkAccountDetails.clientId && formSubmitted,
                  }"
                  type="text"
                  placeholder=" "
                  v-model="externalLinkAccountDetails.clientId"
                ></b-form-input>
                <label for="client-id">Client ID</label>
                <b-form-invalid-feedback
                  class="d-block"
                  v-if="!externalLinkAccountDetails.clientId && formSubmitted"
                  >Client ID required.</b-form-invalid-feedback
                >
              </div>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="12" lg="10">
            <b-form-group>
              <div class="floating-input-field">
                <b-form-input
                  id="client-secret"
                  :class="{
                    'is-invalid':
                      !externalLinkAccountDetails.clientSecret && formSubmitted,
                  }"
                  type="text"
                  placeholder=" "
                  v-model="externalLinkAccountDetails.clientSecret"
                ></b-form-input>
                <label for="client-secret">Client secret</label>
                <b-form-invalid-feedback
                  class="d-block"
                  v-if="
                    !externalLinkAccountDetails.clientSecret && formSubmitted
                  "
                  >Client secret required.</b-form-invalid-feedback
                >
              </div>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="12" lg="10">
            <b-form-group>
              <div class="floating-input-field">
                <b-form-input
                  id="policy"
                  :class="{
                    'is-invalid':
                      !externalLinkAccountDetails.policy && formSubmitted,
                  }"
                  type="text"
                  placeholder=" "
                  v-model="externalLinkAccountDetails.policy"
                ></b-form-input>
                <label for="policy">Policy</label>
                <b-form-invalid-feedback
                  class="d-block"
                  v-if="!externalLinkAccountDetails.policy && formSubmitted"
                  >Policy required.</b-form-invalid-feedback
                >
              </div>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="12" lg="10">
            <b-form-group>
              <div class="floating-input-field">
                <b-form-input
                  id="scope"
                  :class="{
                    'is-invalid':
                      !externalLinkAccountDetails.scope && formSubmitted,
                  }"
                  type="text"
                  placeholder=" "
                  v-model="externalLinkAccountDetails.scope"
                ></b-form-input>
                <label for="scope">Scope</label>
                <b-form-invalid-feedback
                  class="d-block"
                  v-if="!externalLinkAccountDetails.scope && formSubmitted"
                  >Scope required.</b-form-invalid-feedback
                >
              </div>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="12" lg="10">
            <b-form-group>
              <div class="floating-input-field">
                <b-form-input
                  id="grant-type"
                  :class="{
                    'is-invalid':
                      !externalLinkAccountDetails.grantType && formSubmitted,
                  }"
                  type="text"
                  placeholder=" "
                  v-model="externalLinkAccountDetails.grantType"
                ></b-form-input>
                <label for="grant-type">Grant type</label>
                <b-form-invalid-feedback
                  class="d-block"
                  v-if="!externalLinkAccountDetails.grantType && formSubmitted"
                  >Grant type required.</b-form-invalid-feedback
                >
              </div>
            </b-form-group>
          </b-col>
        </b-form-row>
      </b-form>
    </template>
    <template #footer="{}">
      <b-button
        type="button"
        v-activeBlur
        class="btn-h-44"
        variant="outline-secondary"
        @click="onResetExternalLinkAccount"
        >Reset</b-button
      >
      <b-button
        type="button"
        v-activeBlur
        :disabled="saveLoadingIcon"
        @click="onSubmitExternalLinkAccount"
        variant="primary"
        class="ml-3 btn-h-44"
        >Save<b-spinner
          v-if="saveLoadingIcon"
          label="Spinning"
          small
          class="ml-2"
        ></b-spinner>
      </b-button>
    </template>
  </b-sidebar>
</template>
<script>
import { mapState } from 'vuex'
import { DISPLAY_MESSAGES } from '../../utilities/constants'
import { useValidateFields } from '@/composables/useValidateFields'
import { cloneDeep } from 'lodash'
import InfoCircelYellow from '../../assets/svg/info-circle-yellow.svg'

export default {
  name: 'AddEditExternalLinkAccount',
  props: ['showExternalLinkAccountSideBar'],
  setup() {
    const { validateUrl, scrollToErrorMessage } = useValidateFields()

    return { validateUrl, scrollToErrorMessage }
  },
  data () {
    return {
      isEditPage: false,
      authenticationMethod: 'azureB2C',
      cloneExternalLinkAccountDetails: null,
      externalLinkAccountDetails: {
        tenantId: null,
        accountName: null,
        tenantAuthCodeEndPoint: null,
        tenantAccessTokenEndPoint: null,
        policy: null,
        clientId: null,
        clientSecret: null,
        scope: null,
        grantType: null,
        isForEachProperty: false
      },
      externalLinkAccountDetailsLoading: false,
      showForm: true,
      formSubmitted: false,
      saveLoadingIcon: false,
      DISPLAY_MESSAGES: DISPLAY_MESSAGES
    }
  },
  components: {
    InfoCircelYellow
  },
  computed: {
    isAddressSetupDone () {
      return !!(this.selectedTenant.length &&
        !this.selectedTenant[0].isAddressSetupDone)
    },
    restrictAddLinkAccountToMultipleCity () {
      return (
        (this.selectedTenant.length > 1 ||
          this.selectedTenant.some((tenant) => tenant.tenantID === 0)) &&
        !this.isEditPage
      )
    },
    ...mapState({
      selectedTenant: (state) => state.common.selectedTenant
    })
  },
  created () {
    if (this.$route.name === 'Settings-edit-external-link-account') {
      this.isEditPage = true
      this.getExternalLinkAccountDetails()
    }
  },
  mounted () {
    this.cloneExternalLinkAccountDetails = cloneDeep(
      this.externalLinkAccountDetails
    )
    this.setPropertyDependent()
  },
  methods: {
    showToaster (message, key, type) {
      this.$store.commit('common/setCustomToastData', {
        message: message,
        key: key,
        type: type
      })
    },
    getExternalLinkAccountDetails () {
      this.externalLinkAccountDetailsLoading = true
      const postObj = {
        linkAccountId: this.$route.params.id,
        authenticationType: 'external-link-account'
      }
      this.$store
        .dispatch('settings/getLinkAccountDetails', postObj)
        .then((response) => {
          this.externalLinkAccountDetailsLoading = false
          this.externalLinkAccountDetails = response.data
          this.cloneExternalLinkAccountDetails = cloneDeep(response.data)
        })
        .catch(() => {
          this.externalLinkAccountDetailsLoading = false
          this.$store.commit('common/setCustomToastData', {
            message: false,
            key: 'FAILED',
            type: 'danger'
          })
        })
    },
    onResetExternalLinkAccount () {
      this.formSubmitted = false
      this.externalLinkAccountDetails = cloneDeep(
        this.cloneExternalLinkAccountDetails
      )
      this.showForm = false
      this.$nextTick(() => {
        this.showForm = true
      })
    },
    sideBarHidden () {
      this.onResetExternalLinkAccount()
    },
    validateExternalLinkAccountForm () {
      const accountName = !!this.externalLinkAccountDetails.accountName
      const tenantAuthCodeEndPoint = this.externalLinkAccountDetails
        .tenantAuthCodeEndPoint
        ? this.validateUrl(
          this.externalLinkAccountDetails.tenantAuthCodeEndPoint
        )
        : false
      const tenantAccessTokenEndPoint = this.externalLinkAccountDetails
        .tenantAccessTokenEndPoint
        ? this.validateUrl(
          this.externalLinkAccountDetails.tenantAccessTokenEndPoint
        )
        : false
      const policy = !!this.externalLinkAccountDetails.policy
      const clientId = !!this.externalLinkAccountDetails.clientId
      const clientSecret = !!this.externalLinkAccountDetails.clientSecret
      const scope = !!this.externalLinkAccountDetails.scope
      const grantType = !!this.externalLinkAccountDetails.grantType
      this.scrollToErrorMessage()
      return (
        accountName &&
        tenantAuthCodeEndPoint &&
        tenantAccessTokenEndPoint &&
        policy &&
        clientId &&
        clientSecret &&
        scope &&
        grantType
      )
    },
    onSubmitExternalLinkAccount () {
      this.formSubmitted = true
      if (this.validateExternalLinkAccountForm()) {
        this.saveLoadingIcon = true
        const action = this.isEditPage
          ? 'settings/updateLinkAccount'
          : 'settings/addLinkAccount'
        if (!this.isEditPage) {
          this.externalLinkAccountDetails.tenantId = Number(
            this.selectedTenant[0].tenantID
          )
        }
        const postObj = {
          data: this.externalLinkAccountDetails,
          authenticationType: 'external-link-account'
        }
        this.$store
          .dispatch(action, postObj)
          .then((response) => {
            this.saveLoadingIcon = false
            if (response.data && Object.hasOwn(response.data, 'errorMessage')) {
              this.showToaster(response.data.errorMessage, false, 'danger')
            } else if (response.data) {
              this.showToaster(
                false,
                this.isEditPage
                  ? 'UPDATE_EXTERNAL_LINK_ACCOUNT'
                  : 'ADD_EXTERNAL_LINK_ACCOUNT',
                'success'
              )
              this.$store.dispatch('settings/getLinkAccounts')
              this.$emit('closeSideBar')
            } else {
              this.showToaster(false, 'FAILED', 'danger')
            }
          })
          .catch(() => {
            this.saveLoadingIcon = false
            this.showToaster(false, 'FAILED', 'danger')
          })
      }
    },
    setPropertyDependent () {
      if (this.selectedTenant.length && !this.isEditPage) {
        this.externalLinkAccountDetails.isForEachProperty = !!this
          .selectedTenant[0].isAddressSetupDone
      }
    }
  },
  watch: {
    selectedTenant (newValue, oldValue) {
      this.setPropertyDependent()
    }
  }
}
</script>
